import React from 'react';

export const ChevronRight = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <path d="M22 40.8345L34 28.8345L22 16.8345" stroke={color} strokeWidth="2" />
  </svg>
);
